import { ChatMessage } from 'src/common/chat/user-actions.hook';

/**
 * it returns a simplified message-id to attach to DOM as a custom-attribute.
 * This message-id is used for scrolling to the related comment
 */
export const generateMessageId = (messageID: ChatMessage['id']) => messageID.split('-').slice(0, 2).join('');
